const burgerBtn = document.querySelector('.header-menu-btn');
const mobileMenuClose = document.querySelector('.mobile-menu-inner-close');
const mobileMenuList = document.querySelector('.mobile-menu-inner-nav-list');
const mobileMenu = document.querySelector('.mobile-menu');

burgerBtn.addEventListener('click', () => {
    mobileMenu.classList.toggle('!left-0');
});

mobileMenuClose.addEventListener('click', () => {
    mobileMenu.classList.toggle('!left-0');
});

mobileMenuList.addEventListener('click', () => {
    mobileMenu.classList.toggle('!left-0');
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
  
        if (targetId.length > 1) {
          e.preventDefault();
          const target = document.querySelector(targetId);
  
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
});